import React from "react";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import { StoryblokAsset } from "../../../interfaces/Storyblok/StoryblokAsset.interface";
import Image from "../../atoms/Image/Image.atom";
import CustomLink from "../../atoms/CustomLink/CustomLink.atom";
import Email from "../../../assets/svgs/Email.svg";
import Phone from "../../../assets/svgs/Phone.svg";

export interface ContactCardProps extends Blok {
  avatar?: StoryblokAsset;
  name?: string;
  role?: string;
  location?: string;
  email?: string;
  phone_number?: string;
}

const ContactCard: React.FC<ContactCardProps> = ({ _uid, avatar, name, role, location, email, phone_number }) => {
  return (
    <li
      key={_uid}
      className="relative flex w-full min-w-0 flex-col items-start gap-5 overflow-hidden rounded-[24px] bg-White p-6 shadow-lg xl:h-[216px] xl:w-[402.5px]"
    >
      {/*-- location badge --*/}
      {location && (
        <span className="absolute right-0 top-0 rounded-bl-2xl rounded-tr-[24px] bg-SP6/20 px-4 py-2 text-sm font-bold uppercase tracking-wide text-SP6">
          {location}
        </span>
      )}

      {/*-- identity --*/}
      <div className="flex w-full min-w-0 items-center gap-5">
        {avatar?.filename && (
          <div className="h-20 w-20 shrink-0 overflow-hidden rounded-full">
            <Image image={avatar} objectFit="cover" fluidMaxWidth={160} />
          </div>
        )}
        <div className="min-w-0 flex-1">
          {name && (
            <p className="truncate pr-16 text-[19.8px] font-extrabold leading-[29.7px] text-Primary-900">{name}</p>
          )}
          {role && <p className="mt-1 truncate text-[15px] font-normal leading-[20px] text-Body">{role}</p>}
        </div>
      </div>

      {/*-- divider --*/}
      <hr className="w-full border-t border-dashed border-Primary-200" />

      {/*-- contact details --*/}
      <div className="flex w-full min-w-0 flex-col gap-3">
        {email && (
          <CustomLink url={`mailto:${email}`} className="group flex w-full min-w-0 items-center gap-3">
            <Email className="w-5 shrink-0 text-[#38BFA8]" />
            <span className="min-w-0 truncate text-[15px] font-normal leading-[20px] text-Body group-hover:text-SP6">
              {email}
            </span>
          </CustomLink>
        )}
        {phone_number && (
          <CustomLink url={`tel:${phone_number}`} className="group flex min-w-0 items-center gap-3">
            <Phone className="w-5 shrink-0 text-[#38BFA8]" />
            <span className="min-w-0 truncate text-[15px] font-normal leading-[20px] text-Body group-hover:text-SP6">
              {phone_number}
            </span>
          </CustomLink>
        )}
      </div>
    </li>
  );
};

export default ContactCard;
